import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import DocumentBodyFooter from "../../custom/layout/documentBodyFooter.tsx";
import FooterLoader from "../../custom/layout/footerLoader";
import HeaderLoader from "../../custom/layout/headerLoader";
import { storeRoot } from "../state/storeRoot";
import RenderPage from "./renderPage";

const container = document.getElementById("renderApp");

if (container) {
	createRoot(container).render(
		<React.StrictMode>
			<Provider store={storeRoot}>
				<HeaderLoader/>
				<div className="cms-sections">
					<RenderPage url={container.dataset.url}/>
				</div>
				<FooterLoader/>
				<DocumentBodyFooter/>
			</Provider>
		</React.StrictMode>
	);
}
